import IVendorClientConfigRequestData from '../server/requests/contracts/IVendorClientConfigRequestData';
import IBaseVendorGameConfig from '../../core/src/managers/contracts/configurations/game/IBaseVendorGameConfig';
import IGameGeneralConfig from '../../core/src/managers/contracts/configurations/IGeneralGameConfig';
import AbstractGameGeneralConfig from '../../core/src/baseConfigs/AbstractGameGeneralConfig';

export default abstract class AbstractVendorGameGeneralConfig extends AbstractGameGeneralConfig implements IGameGeneralConfig<IVendorClientConfigRequestData>, IBaseVendorGameConfig {
  _clientConfig: IVendorClientConfigRequestData;
  get clientConfig(): IVendorClientConfigRequestData {
    return this._clientConfig
  };
  parseClientConfig(data: IVendorClientConfigRequestData) {
    this._clientConfig = data;
  }
  getRTP(): number {
    let result = this.clientConfig?.gameData?.gameRTP || 0;
    return result;
  }
}
